import React, {useMemo} from "react";
import PageHeader from "@components/Page/PageHeader";
import Page from "@components/Page/Page";
import PageContent from "@components/Page/PageContent";
import PageSection from "@components/Page/PageSection";
import {findFirstSection, getCmsPage} from "@lib/Cms/CmsUtils";
import {ContactForm} from "@pages/Contact/Components/ContactForm/ContactForm";
import {SECTION_TYPE} from "@lib/Cms/CmsModels";
import {MailIcon} from "@components/Icons/MailIcon";
import KvBanner from "@components/KvBanner/KvBanner";

export default function ContactPage() {

    const {sections, banner, ...page} = useMemo(() => getCmsPage("contact") ?? {}, []);

    const defaultSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.DEFAULT), [sections]);
    const formSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.CONTACT_FORM), [sections]);

    return (
        <>
            <Page>

                {!!banner &&
                    <KvBanner name={"faq"} banner={banner}/>
                }

                <PageHeader cms={page}/>

                <PageContent>

                    <PageSection bg={defaultSection?.options?.bgType}>

                        <header className="form__header">
                            <div className="form__icon">
                                <span className="icon"><MailIcon color={"#db3700"}/></span>
                                <span className={"tp-xs semibold color-primary"}>{formSection?.subTitle}</span>
                            </div>
                            <h3 className="form__title tp-xl bold">{formSection?.title}</h3>
                            <p className={"tp-m"}>{formSection?.text}</p>
                        </header>

                        <ContactForm/>

                    </PageSection>

                </PageContent>

            </Page>

        </>
    );
}
